export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.companyId = item != null ? item.companyId : ''
        this.startDate = item != null ? item.startDate : ''
        this.subscriptionType = item != null ? item.subscriptionType : 0
        this.users = item != null ? item.users : 0
        this.administrations = item != null ? item.administrations : 0
    }
}